import axios from '@/libs/axios';

class CrmClient {
  constructor() {
    this.api = axios;
  }

  async getPortfolioQuality() {
    const { data } = await this.api.get('/crm/portfolio-quality');
    return data;
  }

  async listClientes(params) {
    const { data } = await this.api.get('/crm/clientes', { params });
    return data;
  }

  async getCliente(id) {
    const { data } = await this.api.get(`/crm/clientes/${id}`);
    return data;
  }

  async updateCliente(id, payload) {
    const { data } = await this.api.patch(`/crm/clientes/${id}`, payload);
    return data;
  }

  async transferirCliente(id, novoOwnerId) {
    const { data } = await this.api.post(`/crm/clientes/${id}/transferir`, { novo_owner_id: novoOwnerId });
    return data;
  }

  async listPedidos(clienteId) {
    const { data } = await this.api.get(`/crm/clientes/${clienteId}/pedidos`);
    return data;
  }

  async listContatos(clienteId, incluirExcluidos = false) {
    const { data } = await this.api.get(`/crm/clientes/${clienteId}/contatos`, {
      params: { incluir_excluidos: incluirExcluidos ? '1' : '0' },
    });
    return data;
  }

  async createContato(clienteId, payload) {
    const { data } = await this.api.post(`/crm/clientes/${clienteId}/contatos`, payload);
    return data;
  }

  async updateContato(clienteId, seq, clienteiderp, payload) {
    const { data } = await this.api.patch(`/crm/clientes/${clienteId}/contatos/${seq}/${encodeURIComponent(clienteiderp)}`, payload);
    return data;
  }

  async deleteContato(clienteId, seq, clienteiderp) {
    const { data } = await this.api.delete(`/crm/clientes/${clienteId}/contatos/${seq}/${encodeURIComponent(clienteiderp)}`);
    return data;
  }

  async restoreContato(clienteId, seq, clienteiderp) {
    const { data } = await this.api.post(`/crm/clientes/${clienteId}/contatos/${seq}/${encodeURIComponent(clienteiderp)}/restaurar`);
    return data;
  }

  async listNotas(clienteId, params) {
    const { data } = await this.api.get(`/crm/clientes/${clienteId}/notas`, { params });
    return data;
  }

  async createNota(clienteId, payload, file = null) {
    if (file) {
      const formData = new FormData();
      formData.append('conteudo_texto', payload.conteudo_texto || '');
      if (payload.oportunidade_id) formData.append('oportunidade_id', payload.oportunidade_id);
      formData.append('anexo', file, file.name);
      const { data } = await this.api.post(`/crm/clientes/${clienteId}/notas`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    }
    const { data } = await this.api.post(`/crm/clientes/${clienteId}/notas`, payload);
    return data;
  }

  async listAtividades(params) {
    const { data } = await this.api.get('/crm/atividades', { params });
    return data;
  }

  async createAtividade(payload) {
    const { data } = await this.api.post('/crm/atividades', payload);
    return data;
  }

  async updateAtividade(id, payload) {
    const { data } = await this.api.patch(`/crm/atividades/${id}`, payload);
    return data;
  }

  async concluirAtividade(id) {
    const { data } = await this.api.post(`/crm/atividades/${id}/concluir`);
    return data;
  }

  async cancelarAtividade(id, motivo) {
    const { data } = await this.api.post(`/crm/atividades/${id}/cancelar`, { motivo });
    return data;
  }

  async transferirAtividade(id, novoOwnerId) {
    const { data } = await this.api.post(`/crm/atividades/${id}/transferir`, { novo_owner_id: novoOwnerId });
    return data;
  }

  async deleteAtividade(id) {
    const { data } = await this.api.delete(`/crm/atividades/${id}`);
    return data;
  }

  async listOportunidades(params) {
    const { data } = await this.api.get('/crm/oportunidades', { params });
    return data;
  }

  async createOportunidade(payload) {
    const { data } = await this.api.post('/crm/oportunidades', payload);
    return data;
  }

  async updateOportunidade(id, payload) {
    const { data } = await this.api.patch(`/crm/oportunidades/${id}`, payload);
    return data;
  }

  async aniversariosHoje() {
    const { data } = await this.api.get('/crm/aniversarios/hoje');
    return data;
  }

  async aniversariosMes(mes) {
    const { data } = await this.api.get('/crm/aniversarios', { params: { mes } });
    return data;
  }

  async enviarCartaoAniversario(payload) {
    const { data } = await this.api.post('/crm/aniversarios/enviar-cartao', payload);
    return data;
  }
}

export default new CrmClient();
